export interface ITypeSetItem<T> {
    equalTo(other: T): boolean
}

/**
 * @description Set (an item can only occur once in collection) with custom equality comparison. Type T passed in must implement interface ITypeSetItem
 */
export class TypeSet<T extends ITypeSetItem<T>> extends Set<T> {
    constructor(values?: Iterable<T> | null | undefined)
    constructor(values?: readonly T[] | null | undefined) {
        super(values);
    }

    public override add(value: T) : this {
        if (!this.has(value)) {
            super.add(value);
        }
        return this;
    }

    public override has(value: T) {
        let found = false;
        for (const other of this) {
            if (value.equalTo(other)) {
                found = true;
                break;
            }
        }
        return found;
    }

    public toArray() : Array<T> {
        return Array.from(this);
    } 
}
